export default __webpack_public_path__ + "static/media/wix.a8f4a7a0.svg";